import { useContext } from 'react'
import { FirebaseContext } from './FirebaseContext'

export const useFirebaseAnal = () => {
  const context = useContext(FirebaseContext)
  if (context === undefined) {
    throw new Error('useFirebaseAnal must be used within FirebaseProvider')
  }
  return context
}
